/* eslint-disable react/prop-types */
/** @jsxImportSource @emotion/react */

import { useDispatch, useSelector } from 'react-redux';
import { memo } from 'react';
import { nike } from '@nike/nike-design-tokens';

import { RoleContentEnum } from '../../util/RoleContentEnum';
import { TranslatedCopy } from '../../intl/TranslatedCopy';
import Truncator from '../../components/Truncator';
import { invitationsActions } from './actions';
import { invitationsSelectors } from './reducer';

const InvitationTableRow = memo(({ invitation, invitationIsSelected }) => {
  const dispatch = useDispatch();

  const invitationsActiveReview = useSelector(invitationsSelectors.activeReview);

  return (
    <tr
      css={{
        background: invitationIsSelected ? nike.podiumCdsColorBgAlwaysDark : nike.podiumCdsColorBgAlwaysLight,
        color: invitationIsSelected ? nike.podiumCdsColorTextPrimaryInverse : nike.podiumCdsColorTextPrimary,
        height: '50px',
        '&:not(:first-child)': {
          borderTop: `1px solid ${nike.podiumCdsColorBorderPrimary}`
        },
        '&:hover': {
          background: nike.podiumCdsColorGrey200,
          transition: 'background 0.5s'
        },
        '& > td': {
          padding: '14px'
        }
      }}
      onClick={() => {
        dispatch({ type: invitationsActions.selectInvitation.name, payload: invitation.id });
      }}
    >
      <td
        css={{
          display: invitationsActiveReview ? 'table-cell' : 'none',
          width: '42%',
          '@media (min-width: 769px)': {
            display: 'table-cell',
            width: '27%'
          }
        }}
      >
        <Truncator value={invitation.email} />
      </td>
      <td
        css={{
          width: '16%',
          '@media (min-width: 769px)': {
            width: '20%'
          }
        }}
      >
        <div
          css={{
            background: invitationIsSelected ? nike.podiumCdsColorWhite : nike.podiumCdsColorBlack,
            borderRadius: '5px',
            color: invitationIsSelected ? nike.podiumCdsColorBlack : nike.podiumCdsColorWhite,
            display: 'inline-block',
            marginRight: '12px',
            width: '20px',
            '&:before': {
              alignItems: 'center',
              content: RoleContentEnum[invitation.role],
              display: 'flex',
              fontSize: '12px',
              fontWeight: 'bold',
              height: '20px',
              justifyContent: 'center'
            }
          }}
        />
        <span
          css={{
            verticalAlign: 'middle',
            display: 'none',
            '@media (min-width: 769px)': {
              display: 'inline'
            }
          }}
        >
          <TranslatedCopy id={`userManagement.roles.${invitation.role.toLowerCase()}`} />
        </span>
      </td>
      <td
        css={{
          width: '42%',
          '@media (min-width: 769px)': {
            width: '13%'
          }
        }}
      >
        <TranslatedCopy id={`userManagement.status.${invitation.status.toLowerCase()}`} />
      </td>
    </tr>
  );
});

export default InvitationTableRow;
